<template>
    <el-row class="main-box">
        <el-col >
				<el-col class="listdivcls" :xs="{span:22,offset:1}" :sm="{span:22,offset:1}"  :md="{span:22,offset:1}" :lg="{span:20,offset:2}">
					<el-row>
					<el-col  :md="{span:17}" :xs="{span:23}" :sm="{span:23}" style="height: 428px;">
					<div class="texttitle" style="margin-top: 30px;">公司介绍</div>
					<div style="margin-top: 20px;line-height: 31px;height: 312px;overflow: hidden;" v-html="data.introduce"	></div>
					</el-col>
					<el-col :span="7"  class="hidden-sm-and-down">
						<el-image class="main-box-bg":src="require('@/static/abou_ic1.png')" fit="cover"></el-image>
					</el-col>
					</el-row>
				</el-col> 
			
			<el-col class="listdivcls2" :xs="{span:22,offset:1}" :sm="{span:22,offset:1}"  :md="{span:22,offset:1}" :lg="{span:20,offset:2}">
				<div class="texttitle" style="margin-top: 30px;">优秀教练</div>
				<el-row :gutter="30" style="margin-top: 20px;">
					<el-col :span="12"> 
								<div class="rwclsotr flex-row" style="overflow: hidden;">
									<el-image class="eliamng" :src="userdata1.avatar" fit="cover"></el-image> 
									<div class="flex-column flex1 f-justify-center" style="margin-left:34px ; overflow: hidden;">
										 <div>
											<span style="font-size: 36px;
											font-weight: bold;
											">{{userdata1.name}}</span>
											 <span  style="margin-left: 22px">{{userdata1.job}}</span>
										 </div>
										 <div style="margin-top: 10px;margin-right: 10px;padding-bottom: 10px;">
											<el-tooltip  effect="dark"  placement="top-end">
												<div slot="content">{{userdata1.introduce}}</div>
												<span > {{userdata1.introduce}}</span>
											</el-tooltip>
										 </div>
									</div>
								</div>
					</el-col>
					<el-col :span="12">
							<div class="rwclsotr flex-row" style="overflow: hidden;">
								<el-image class="eliamng" :src="userdata2.avatar" fit="cover"></el-image> 
								<div class="flex-column flex1 f-justify-center" style="margin-left:34px ; overflow: hidden;">
									 <div>
										<span style="font-size: 36px;
										font-weight: bold;
										">{{userdata2.name}}</span>
										 <span  style="margin-left: 22px">{{userdata2.job}}</span>
									 </div>
									 <div style="margin-top: 10px;margin-right: 10px;padding-bottom: 10px;">
										  <el-tooltip  effect="dark"  placement="top-end">
										  	<div slot="content">{{userdata2.introduce}}</div>
										  	<span > {{userdata2.introduce}}</span>
										  </el-tooltip>
										  
										 </div>
								</div>
							</div>
					</el-col>
				</el-row> 
				<el-row style="margin-top: 30px;">
					<el-col>
							<div class="gridcls">
							<div class="abou_itemcls flex-column" style="overflow: hidden;" v-for="(itemdata, indexdata) in datalist" :key="indexdata">
								<div class="flex-row">
										<div class="headlcs">
											<el-image class="eliamng2" :src="itemdata.avatar" fit="cover"></el-image> 
										</div>
										<div class="flex-column flex1 f-justify-center" style="margin-left: 20px;">
											<span style="font-weight: bold;font-size: 28px;">{{itemdata.name}}</span>
											<span style="font-weight: bold;margin-top: 4px;">{{itemdata.job}}</span>
										</div>
								</div>
								<div style="margin-top: 17px;line-height: 30px;">
									
									<el-tooltip  effect="dark"  placement="top-end">
										<div slot="content">{{itemdata.introduce}}</div>
										<span > {{itemdata.introduce}}</span>
									</el-tooltip>
									
								</div>
							</div>
							</div>
					</el-col>
				</el-row> 
			
			</el-col> 
			
        </el-col>

    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    data() {
        return {
			datalist:[],
			data:{},
			userdata1:{},
			userdata2:{},
			}
    },
   computed: {
   ...mapState([
          'userToken',
		   'userInfos',
      ]),
      ...mapGetters(["getUserToken"])
   },
	created() {
	    this.getdata();
	},
    methods: {
		async getdata() {
		    let res = await this.$api.get("/web/teacher/home/queryAboutUs", {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        },
				params:{
					id:this.id ,
				 }
		    });
			if(res.code==200)
			{
				this.data=res.data;
				// this.datalist=this.data.aboutUsPersonListVos;
				if(this.data.aboutUsPersonListVos.length>2)
				{
					this.datalist=this.data.aboutUsPersonListVos.slice(2,this.data.aboutUsPersonListVos.length);
				}
				if(this.data.aboutUsPersonListVos.length>0)
				{
				this.userdata1=this.data.aboutUsPersonListVos[0];
				}
				if(this.data.aboutUsPersonListVos.length>1)
				{
				this.userdata2=this.data.aboutUsPersonListVos[1];
				}
			}
		},
		
    }
}
</script>

<style lang="scss" scoped>
.main-box {
    width: 100%;
    position: relative;
	   background: #E5F3F1;

    .main-box-bg {
        width: 100%;
        height: 428px;
        position: relative;
        top: 0;
        left: 0;
    }
	
	.listdivcls{
	  padding-left: 30px;
	  margin-top: 40px;
	  border-radius: 20px;
	  background: #FFFFFF;
	  font-family: 思源黑体;
	  font-size: 18px;
	  font-weight: normal;
	  line-height: normal;
	  letter-spacing: 0em;
	  
	  font-feature-settings: "kern" on;
	  /* 333333 */
	  color: #333333;
	}
	.listdivcls2{
	  padding: 30px;
	  margin-top: 30px;
	  border-radius: 20px;
	  background: #FFFFFF;
	  margin-bottom:40px;
	  font-family: 思源黑体;
	  font-size: 18px;
	  font-weight: normal;
	  line-height: normal;
	  letter-spacing: 0em;
	  font-feature-settings: "kern" on;
	  /* 333333 */
	  color: #333333;
	}
}

.texttitle{
	/* 9月优秀学员 */
	font-family: 思源黑体;
	font-size: 26px;
	font-weight: bold;
	line-height: normal;
	letter-spacing: 0em;
	font-feature-settings: "kern" on;
	/* 333333 */
	color: #333333;
}

.gridcls{
	display: grid;
	margin-top: 43px;
    grid-template-columns: repeat(auto-fill, 284px);
	justify-content: space-between;
	gap: 30px 30px;
}

.itembgcls{
	left: 30px;
	top: 111px;
	height: 470px;
	box-sizing: border-box;
	display:inline-grid;
	
	.bgimgcls{
		/* 圆形 31 */
		position: relative;
		left: 21px;
		top: 15px;
		width: 242px;
		height: 242px;
		opacity: 1;
		box-sizing: border-box;
	}
	
	.itemimag2{
		position: absolute;
		left: 46px;
		top: 0px;
		width: 192px;
		height: 236px;
		border-radius: 0px 0px 90px 90px;
		opacity: 1;
	}
	.bgcls2{
		/* 圆形 32 */
		position: absolute;
		left: 42px;
		top: 36px;
		width: 200px;
		height: 200px;
		border-radius: 200px;
		background: #0AA26B;
	}
	
	
	.bgcls3{
		/* 矩形 5 */
		
		position: absolute;
		left: 0px;
		top: 52px;
		width: 284px;
		height: 418px;
		border-radius: 20px;
		opacity: 1;
		background: linear-gradient(180deg, #FFFFFF 7%, #D9F1E5 50%);
		box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);
	}
	.text{
		font-weight: bold;
		line-height: 30px;
		text-align: center;
		/* 绿 */
		color: #0AA26B;
	}
	.textdivlcs{
		position: relative;
		margin-top: 13px;
		font-family: 思源黑体;
		font-size: 18px;
		font-feature-settings: "kern" on;
		letter-spacing: 0em;
		padding-left: 20px;
		padding-right: 20px;
	}
	
}
.abou_itemcls{
	/* 矩形 5 */
	height: 260px;
	border-radius: 20px;
	background: #E5F7F1;
	padding: 27px;
	box-sizing: border-box;
	border: 1px solid rgba(10, 162, 107, 0.2);
}
.headlcs{
width: 88px;
height: 88px;
border-radius: 8px;
opacity: 1;
	overflow: hidden;
/* 绿 */
background: #0AA26B;
	
}

.rwclsotr{
	height: 260px;
	border-radius: 20px;
	opacity: 1;
	background: radial-gradient(17% 36% at 17% 90%, #FF470A 0%, rgba(255, 129, 88, 0.0501) 99%, rgba(255, 127, 85, 0) 100%), linear-gradient(270deg, rgba(10, 162, 107, 0.9) 0%, rgba(10, 162, 107, 0.6) 100%);
	font-family: Source Han Sans;
	font-size: 18px;
	font-weight: normal;
	line-height: normal;
	letter-spacing: 0em;
	
	font-feature-settings: "kern" on;
	/* 纯白 */
	color: #FFFFFF;
	
	.eliamng{
		height: 100%;
		width: 30%;
	}
}


.gridcls{
	display: grid;
	margin-top: 43px;
    grid-template-columns: repeat(auto-fill, 31.37%);
	justify-content: space-between;
	gap: 30px 0;
	
	
	.eliamng2{
		height: 100%;
		width: 100%;
	}
}

</style>